import React from 'react';
import type { AdSlot } from '@/lib/api-client';

function ensureAbsoluteUrl(url: string): string {
  if (!url) return '#';
  if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith('//')) return url;
  return `https://${url}`;
}

interface TopAdBannerProps {
  slot?: AdSlot;
}

export default function TopAdBanner({ slot }: TopAdBannerProps) {
  if (slot?.isActive && slot.imageUrl) {
    return (
      <div className="w-full flex justify-center bg-surface border-b border-default py-2" style={{ minHeight: '90px' }}>
        <a href={ensureAbsoluteUrl(slot.targetUrl)} target="_blank" rel="noopener noreferrer">
          {/* eslint-disable-next-line @next/next/no-img-element */}
          <img src={slot.imageUrl} alt={slot.altText} style={{ maxHeight: '90px', objectFit: 'contain' }} />
        </a>
      </div>
    );
  }

  return (
    <div
      className="ad-banner-placeholder w-full flex items-center justify-center border-b border-default"
      style={{ height: '90px' }}
    >
      <div className="text-center">
        <p className="text-[10px] text-slate-600 uppercase tracking-widest mb-1">Advertisement</p>
        <p className="text-fg-subtle text-sm font-medium">Your Ad Here — 728×90 Banner</p>
        <a
          href="/advertise"
          className="text-xs text-sky-500 hover:text-sky-400 transition-colors mt-0.5 inline-block"
        >
          Advertise with Us
        </a>
      </div>
    </div>
  );
}
